// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./SnippetForm";
export type { SnippetFormOwnProps } from "./SnippetForm";
